import React from 'react';
import styled from '@emotion/styled';
import { colors } from '@modernhealth/vital-foundation';
import { BodyTextMedium, HeadingText50 } from '@modernhealth/vital-components';
import { Trans, useTranslation } from 'react-i18next';

import { Page } from '../components/PageLayout';
import { BackButton } from '../components/BackButton';

const StyledList = styled.ul`
    list-style: disc;
    padding: 24px;
    max-width: 750px;

    & > li {
        &::marker {
            color: ${colors.gray65};
        }

        margin-bottom: 24px;
    }
`;

export const CirclesCommunityGuidelinesPage: React.FC<unknown> = () => {
    const { t } = useTranslation('circles');

    // Our version of react-18next doesn't handle returnObjects types correctly
    const bullets = t('pages.guidelines.bullets', { returnObjects: true }) as string[];

    return (
        <Page.Container>
            <Page.Header>
                <BackButton fallbackPath="/circles" />
            </Page.Header>
            <Page.Content
                centered
                css={{
                    width: 800,
                    maxWidth: '90vw',
                }}
            >
                <div css={{ marginBottom: 32 }}>
                    <HeadingText50 fontColor="gray85" css={{ marginBottom: 16 }}>
                        <Trans
                            t={t}
                            i18nKey="pages.guidelines.header"
                            components={{
                                bold: <span css={{ color: colors.blue55 }} />,
                            }}
                        />
                    </HeadingText50>
                    <BodyTextMedium fontColor="gray65">
                        <Trans
                            t={t}
                            i18nKey="pages.guidelines.description"
                            components={{
                                i: <span css={{ fontStyle: 'italic' }} />,
                            }}
                        />
                    </BodyTextMedium>
                </div>

                <StyledList>
                    {bullets.map((message, i) => (
                        <li key={i}>
                            <BodyTextMedium fontColor="gray65" as="p">
                                {/* eslint-disable-next-line */}
                                <Trans
                                    components={{
                                        bold: (
                                            <span
                                                css={{
                                                    color: colors.gray85,
                                                    fontWeight: 600,
                                                    display: 'inline',
                                                }}
                                            />
                                        ),
                                    }}
                                >
                                    {message}
                                </Trans>
                            </BodyTextMedium>
                        </li>
                    ))}
                </StyledList>
            </Page.Content>
        </Page.Container>
    );
};
